import {Proposal, ProposalQuoteDetails} from 'Quoting/models/DTOs/Proposal';
import axios from 'Shared/utilities/axiosInstance';
import {getAxiosConfig, handleResponse} from 'Shared/utilities/fetchHelpers';
import {getAPIUrl} from './config';

const fieldsFilterForPoliciesWithRates = {
  masterFields: [
    'benefitPackagingDetail.plans.planCd',
    'accessTrackInfo.updatedOn',
    'policyNumber',
    'transactionDetails.txEffectiveDate',
    'state',
    'productCd',
  ],
  rateFields: [
    'rateAggregates.accessTrackInfo.createdOn',
    'rateAggregates.ratePremiumEntry.policy.plans.coverages.rateCard.numberOfLives',
  ],
};

const getAxiosConfigAndHeaders = () => {
  const axiosConfig = getAxiosConfig();

  return {
    ...axiosConfig,
    headers: {
      ...axiosConfig.headers,
    },
  };
};

export default {
  getProposalList: async (rootId: string, customerNumber: string) => {
    const endpoint = `${customerNumber}/${rootId}/proposals-with-quotes?limit=100`;
    const response = await axios.get<Proposal[]>(getAPIUrl(endpoint), getAxiosConfigAndHeaders());
    return handleResponse(response);
  },

  getQuotesLinkedToProposal: async (proposalQuoteLinks: string[], limitFields: boolean = false) => {
    let requestPayload = {
      masterLinks: [...proposalQuoteLinks],
    };

    if (limitFields) {
      requestPayload = {...requestPayload, ...fieldsFilterForPoliciesWithRates};
    }

    const endpoint = 'retrieve-policies-with-rates';
    const response = await axios.post<ProposalQuoteDetails[]>(
      getAPIUrl(endpoint),
      requestPayload,
      getAxiosConfigAndHeaders()
    );
    return handleResponse(response);
  },
};
